import Vue from 'vue'

import moment from 'moment'
import throttle from 'lodash/throttle'

const userAnswer = {
  questionID: 0,
  optionIDs: [],
  answer: ''
}

const option = {
  id: 0,
  tag: '',
  value: ''
}

export default {
  data: function () {
    return {
      loading: false,
      error: '',
      successMessage: '',
      questions: [],
      answers: [],
      errors: [],
      loadingQuestions: false,
      userAnswer,
      option
    }
  },
  computed: {
    hasResource: function () {
      return this.project.resource && this.project.resource.id > 0
    },
    resourceType: function () {
      return this.project.resource.type.name
    },
    webinarDateUnformatted: function () {
      return this.hasResource && this.isWebinar ? moment.utc(this.project.resource.webinar.webinar_date) : ''
    },
    webinarDate: function () {
      var webinarTime = moment.tz(this.project.resource.webinar.webinar_date, this.project.resource.webinar.webinar_time_zone)
      return webinarTime.format('MMMM DD YYYY, h:mmA z')
    },
    isWebinar: function () {
      return this.project?.resource?.type?.name === 'webinar'
    },
    isPastWebinar: function () {
      var webinarEndTime = moment(this.webinarDateUnformatted).add(1, 'hours')
      return this.isWebinar ? moment().isAfter(webinarEndTime) : false
    },
    showEmbeddedVideo: function () {
      if (this.isPastWebinar && this.isRegistered) {
        return true
      }
    },
    isRegistered: function () {
      return this.$store.getters.isRegistered
    },
    isUpcoming: function () {
      var webinarTime = moment.tz(this.project.resource.webinar.webinar_date, 'America/New_York')
      return moment().isBefore(moment(webinarTime).add(0.5, 'hours'))
    }
  },
  methods: {
    trackUserResourceDownload: throttle(function () {
      const data = {
        resourceID: this.project.resource.id,
        utmCampaign: this.$route.query.utm_campaign,
        utmSource: this.$route.query.utm_source,
        utmMedium: this.$route.query.utm_medium
      }
      this.$store.dispatch('saveUserResourceDownload', data)
    }, 500, { leading: true, trailing: false }),
    trackGatedProjectUserDownload: throttle(function () {
      const data = {
        projectID: this.project.id,
        utmCampaign: this.$route.query.utm_campaign,
        utmSource: this.$route.query.utm_source,
        utmMedium: this.$route.query.utm_medium
      }
      this.$store.dispatch('saveGatedProjectUserDownload', data)
    }, 500, { leading: true, trailing: false }),
    validateQuestions: function (shouldSetErrors) {
      let isValid = true
      for (let i = 0; i < this.answers.length; i++) {
        const isSelected = this.isOptionSelected(this.answers[i].optionIDs)
        if (this.answers[i].answer === '' && !isSelected) {
          if (shouldSetErrors) {
            Vue.set(this.errors, i, 'Please provide an answer')
            this.$nextTick(() => {
              const rect = document.getElementById('error-container')
              rect.scrollIntoView({ block: 'center', behavior: 'smooth' })
            })
          }
          isValid = false
        } else if (shouldSetErrors) {
          Vue.set(this.errors, i, '')
        }
      }
      return isValid
    },
    isOptionSelected: function (options) {
      for (const option in options) {
        if (option) {
          return true
        }
      }
      return false
    },
    submitAnswers: function (isDownload) {
      this.error = ''
      this.successMessage = ''

      this.loading = true
      const answers = JSON.parse(JSON.stringify(this.answers))

      answers.forEach((answer) => {
        if (answer.optionIDs.length > 0) {
          answer.answer = answer.optionIDs[0].value
          answer.optionIDs[0] = answer.optionIDs[0].id
        }
      })

      const data = {
        answers
      }

      if (this.fullName) {
        data.fullName = this.fullName.trim()
      }
      if (this.firstName) {
        data.firstName = this.firstName.trim()
      }
      if (this.lastName) {
        data.lastName = this.lastName.trim()
      }
      if (this.email) {
        this.email = this.email.trim()
        if (this.email.length > 0) {
          data.email = this.email
        }
      }
      if (this.webinarID) {
        data.webinarInfo = { webinarID: this.webinarID, isUpcoming: this.isUpcoming }
      }
      this.$store.dispatch('saveUserResourceAnswers', data).then(() => {
        if (isDownload && this.project.resource != null) {
          this.trackUserResourceDownload()
          if (this.isPastWebinar) {
            this.close(true)
          } else {
            if (this.isUpcoming) {
              this.trackResourceDownloadForGA()
            }
            this.counter += 1
          }
        }
        this.successMessage = this.$t('resource.successSaveAnswers')
        this.loading = false
        if (this.editMode) {
          this.editMode = false
        }
      }, err => {
        this.error = err
        this.loading = false
      })
    }
  }
}
